import { jsx } from 'react/jsx-runtime';

const FlexItem = ({ grow, shrink }) => {
  return /* @__PURE__ */ jsx("div", { style: { display: "block", flexGrow: grow, flexShrink: shrink } });
};

export { FlexItem };
//# sourceMappingURL=FlexItem.js.map
